import { render, staticRenderFns } from "./DeliveryStepList.vue?vue&type=template&id=4ba0de23&scoped=true&"
import script from "./DeliveryStepList.vue?vue&type=script&lang=js&"
export * from "./DeliveryStepList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba0de23",
  null
  
)

export default component.exports